// removed by extract-text-webpack-plugin
module.exports = {"noteIconWrapper":"_2_8Wm3yp4tFp_artAT-eg-","noteIcon":"_3EWipAlEN3lQyuJSbyTqLG","noteTooltip":"_1jbpoxSld1c8sJ8HOAwFKl","propertySummary":"j__lKXrHsVQstq9okaKf1","propertyType":"_2VXE4YfzvGXc81Q9Uh-w3u","propertyAddress":"f5C6c_Ly3rbOH6azTDMKZ","propertyPrice":"_3hn9jc-l8htS4DFNJCULcI","label":"_29dO1l9Vnm7G3R830XC7mQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FullScreenPropertyCell/FullScreenPropertyCellPropertySummary/FullScreenPropertyCellPropertySummary.scss
// module id = 1604
// module chunks = 0